module.exports = __webpack_public_path__ + "fonts/fa-solid-900.d824df7e.woff2";